import _regeneratorRuntime from "/usr/local/share/.config/yarn/global/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import { _ as e, e as r, a as t } from "../../../../_rollupPluginBabelHelpers-d2f9cf82.js";
import n, { useContext as o, useState as a, useEffect as i } from "react";
import c from "google-map-react";
import s from "../../../../services/Map.js";
import l from "../../../../contexts/state-context.js";
import p from "../../../../contexts/map-context.js";
import m from "../../GoogleMap/GMap/Marker/Marker.js";
import "../../../../services/GMap.js";
import "axios";
import "../../../../services/Tracking/Tracking.js";
import "../../../../services/Tracking/FacebookPixel.js";
import "../../../../services/Tracking/Pl.js";
import "../../../../services/ApiRequests.js";
import "../../../../services/Tracking/GoogleAnalitycs.js";
import "../../../../services/Utils.js";
import "../../../../services/Tracking/GoogleTagManager.js";
import "../../../../services/Geoapify.js";
import "../../../../services/Url.js";
import "../../../../style-inject.es-1f59c1d0.js";
var u = function (u) {
  var g,
    f = u.mapSize,
    v = u.balloon,
    d = u.mapConfig,
    k = void 0 === d ? {
      styles: []
    } : d,
    j = u.markers,
    y = void 0 === j ? {} : j,
    L = u.merchants,
    h = {
      balloon: {
        style: (null == v ? void 0 : v.style) || {}
      },
      markers: {
        store: (null == y ? void 0 : y.store) || s.gmapService.storesIcon,
        user: (null == y ? void 0 : y.user) || s.gmapService.locationIcon
      }
    },
    x = o(p),
    M = e(x, 2),
    G = M[0],
    S = M[1],
    I = o(l),
    T = e(I, 1)[0],
    b = L || T.merchants,
    w = a({}),
    z = e(w, 2),
    C = z[0],
    R = z[1],
    A = a(s.gmapService.defaultConfig),
    E = e(A, 2),
    U = E[0],
    P = E[1],
    _ = a(""),
    B = e(_, 2),
    D = B[0],
    K = B[1],
    O = function () {
      var e = r(_regeneratorRuntime.mark(function e(r, n) {
        var o, a;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, s.gmapService.initGMap(T, r);
            case 2:
              o = e.sent, S(t(t({}, G), o)), G.placeLoc.lat && G.placeLoc.lng && (a = {
                lat: G.placeLoc.lat,
                lon: G.placeLoc.lng
              }, F(a)), q(r, n);
            case 6:
            case "end":
              return e.stop();
          }
        }, e);
      }));
      return function (r, t) {
        return e.apply(this, arguments);
      };
    }(),
    q = function (e, r) {
      r.event.addDomListenerOnce(e, "idle", function () {
        r.event.addDomListener(window, "resize", function () {
          var e = s.gmapService.GMaps.placeLoc;
          e && s.gmapService.centerOnStores(b, e);
        });
      });
    },
    F = function () {
      var e = r(_regeneratorRuntime.mark(function e(r, t) {
        var n, o, a, i, c;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, s.gmapService.refreshMap(t, b, r);
            case 2:
              n = e.sent, o = n.lat, a = n.lng, i = n.zoom, c = n.place, R({
                lat: c.lat,
                lng: c.lng
              }), P({
                center: {
                  lat: o,
                  lng: a
                },
                zoom: i
              });
            case 9:
            case "end":
              return e.stop();
          }
        }, e);
      }));
      return function (r, t) {
        return e.apply(this, arguments);
      };
    }();
  return i(function () {
    var e = G.placeId;
    if (e && G.scriptInited) {
      F(undefined, e);
    }
  }, [G.placeId]), i(function () {
    if (G.placeLoc.lat && G.placeLoc.lng && G.scriptInited) {
      var e = {
        lat: G.placeLoc.lat,
        lon: G.placeLoc.lng
      };
      F(e);
    }
  }, [G.placeLoc.lat, G.placeLoc.lng]), n.createElement("div", {
    style: f
  }, n.createElement(c, {
    bootstrapURLKeys: {
      key: G.apiKeys.default,
      libraries: ["places"]
    },
    zoom: U.zoom,
    center: U.center,
    yesIWantToUseGoogleMapApiInternals: !0,
    onGoogleApiLoaded: function (e) {
      var r = e.map,
        t = e.maps;
      return O(r, t);
    },
    onChildClick: function (e) {
      K(e);
    },
    options: function (e) {
      var r = s.gmapService.mapControlConfig;
      return t(t({}, r), k);
    }
  }, T.merchants && !(null != T && null !== (g = T.sl) && void 0 !== g && g.home_search) && n.createElement(m, {
    lat: C.lat,
    lng: C.lng,
    key: "user",
    icon: h.markers.user,
    config: h
  }), b && b.length > 0 && b.map(function (e) {
    return n.createElement(m, {
      lat: e.latitude,
      lng: e.longitude,
      merchant: e,
      icon: h.markers.store,
      displayBalloon: D === e.id,
      key: e.id,
      config: h
    });
  })));
};
export { u as default };